import type { IconProps } from "../types";

export const Minimize = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M8 3v5H3" />
    <path d="M21 8h-5V3" />
    <path d="M3 16h5v5" />
    <path d="M16 21v-5h5" />
  </svg>
);
